export default "__VITE_ASSET__f19dc789__"